export const ME = '/assets/images/other/getUser.jpg';
export const ME_CUT = '/assets/images/other/mecut.jpg';
export const ME_CUT_REMOVE_BG = '/assets/images/other/mecut-removebg.png';
